import { render } from "./Lists.vue?vue&type=template&id=11630eea&scoped=true"
import script from "./Lists.vue?vue&type=script&lang=js"
export * from "./Lists.vue?vue&type=script&lang=js"

import "./Lists.vue?vue&type=style&index=0&id=11630eea&scoped=scoped&lang=css"

import exportComponent from "D:\\wcb\\www\\clpga_htmlgit\\f_pc\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11630eea"]])

export default __exports__